import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import PrepackSetting from 'components/Admin/PrepackSetting';
// eslint-disable-next-line
export default () => {
  return (
    <ContentLayout>
      <SiteContent>
        <PrepackSetting />
      </SiteContent>
    </ContentLayout>
  );
};
